// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"c996257c","232":"581f7b40","237":"ea550091","357":"6d4e504e","526":"05d93336","753":"c23ea625","854":"6cdd86e8","872":"ee622f3e"}[chunkId] + ".chunk.js";
};